<script lang="ts" setup>
import ConfirmationPopper from './ConfirmationPopper.vue'

defineProps({
  label: { type: String, default: 'Exporter' },
})
defineEmits(['cancel', 'confirm'])
</script>

<template>
  <confirmation-popper
    content="Le fichier contiendra des données confidentielles"
    confirm-label="Exporter"
    @confirm="$emit('confirm', $event)"
    @cancel="$emit('cancel', $event)"
  >
    <template #button>
      <slot name="button">
        <button class="btn btn-start-rss-pipeline">
          {{ label }}
        </button>
      </slot>
    </template>
  </confirmation-popper>
</template>
